<template>
  <div id="rule">
    <p>
      电信诈骗无孔不入，各行各业都有人上当，随时随地都会发生，特别是近年来，温岭电信诈骗案件高发，防范电信诈骗的形势特别严峻。
    </p>
    <p>
      1月10日，温岭市委宣传部联合市公安局、市融媒体中心推出为期一个月的“全民来反诈
      无忧过兔年”反诈小视频集中有奖观看活动，精选30个有影响力、有感染力的反诈宣传视频在掌上温岭App展示，努力营造春节假期防骗反诈宣传氛围，力争诈骗案件断崖式下降，进一步守护温岭人的钱袋子。
    </p>
    <h3>活动时间</h3>
    <p>1月10日-2月8日</p>

    <h3>活动说明</h3>
    <p>
      【看一看】看完反诈视频，就能参与抽奖，每人每天限抽奖1次。次日可重复观看并抽奖。
    </p>
    <p>
      【答一答】参与答题学习，答完3题且全对的情况下，可获得1次抽奖。每人每天仅限抽奖1次。次日可重复答题并抽奖。
    </p>
    <p>
      【比一比】村居观看人数排名前十名、学校参与率排名前十名，授予“最佳反诈单位”荣誉称号，并颁发证书。
    </p>
    <h3>奖品说明</h3>
    <p>牛听听儿童绘本阅读机</p>
    <p>100元中石化加油卡</p>
    <p>爱仕达奶锅</p>
    <p>警察节定制徽章</p>
    <p>反诈定制钥匙扣</p>
    <p>2023文明周历</p>
    <p>加热桌垫</p>
    <p>帆布袋</p>

    <h3>领取规则</h3>
    <p>
      所有奖品将于2月8活动结束后安排领奖，可提前加温小闻微信，静待通知。
    </p>
    <div class="qr">
      <img
        src="https://i.tmuyun.com/webpic/W0202201/W020220121/W020220121619042190624.jpg"
        alt=""
      />
    </div>
    <p>保存二维码，及时了解活动信息</p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
#rule {
  background-color: #ffe9bb;
  border-radius: 10px;
  color: #000;
  padding: 10px;
}
p {
  text-indent: 2em;
}

.qr {
  text-align: center;
  width: 50vw;
  margin: auto;
  img {
    width: 100%;
  }
}
</style>
